import React from 'react';

interface TableIconProps {
  className?: string;
}

/* viewBox padded so the glyph fills ~72% of its box — the band the heroicons beside it
   in the TanTable toolbar occupy. The source art draws 2..22 of 24 (83%), which
   rendered taller than its neighbours at the same h-4 w-4. Padding is on the viewBox,
   not the path, so the artwork is untouched. See ICON SIZING in TanTable.tsx. */
const TableIcon: React.FC<TableIconProps> = ({ className = 'h-5 w-5' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1.89 -1.89 27.78 27.78"
      fill="currentColor"
      className={className}
    >
      <path d="M19.5,2H4.5C2.019,2,0,4.019,0,6.5v11c0,2.481,2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5V6.5c0-2.481-2.019-4.5-4.5-4.5ZM4.5,3h15c1.93,0,3.5,1.57,3.5,3.5v.5H1v-.5c0-1.93,1.57-3.5,3.5-3.5ZM1,17.5V8H7v13h-2.5c-1.93,0-3.5-1.57-3.5-3.5Zm18.5,3.5H8V8h15v9.5c0,1.93-1.57,3.5-3.5,3.5Z"/>
    </svg>
  );
};

export default TableIcon;
